import { Button } from '@/components';
import { DropdownWrapper, MenuItems } from '@/components/Header/styles';
import { useOnClickOutside } from '@/libs/hooks';
import SolidSVG, { IconMenu } from '@/libs/SolidSVG';
import { FC, memo, useCallback, useContext, useRef, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';

const menuItems = [
  {
    type: 'postback',
    title: 'Menu',
    payload: 'Main Menu',
  },
  {
    type: 'postback',
    title: 'Recharge',
    payload: 'Recharge',
  },
];

export type ButtonMenuProps = {
  onMenuItemClick?: (item: typeof menuItems[0]) => void;
};

export const ButtonMenu: FC<ButtonMenuProps> = memo(({ onMenuItemClick }) => {
  const [isDropdownMenu, setDropdownMenu] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(dropdownRef, () => setDropdownMenu(false));
  const toggleDropdown = useCallback(() => setDropdownMenu((prev) => !prev), []);

  const {
    colors: { primary },
  } = useContext(ThemeContext);

  const handleClick = (item: typeof menuItems[0]) => {
    onMenuItemClick?.(item);
    toggleDropdown();
  };

  return (
    <Wrapper ref={dropdownRef}>
      <Button type="button" variant="link" rounded="circle" onClick={toggleDropdown}>
        <SolidSVG path={IconMenu} fill={primary} width={28} height={28} />
      </Button>

      <DropdownItems className={isDropdownMenu ? 'active' : ''}>
        <ul>
          {menuItems.map((item, i) => (
            <li key={i}>
              <Button type="button" variant="link" onClick={() => handleClick(item)}>
                {item.title}
              </Button>
            </li>
          ))}
        </ul>
      </DropdownItems>
    </Wrapper>
  );
});

const Wrapper = styled(DropdownWrapper)`
  margin-left: 5px;

  & > button {
    padding: 0;
    width: 34px;
    height: 34px;
  }
`;

const DropdownItems = styled(MenuItems)`
  top: inherit !important;
  bottom: calc(100% + 0.625rem);
  right: -15px;
  z-index: 99;
  background-color: ${({ theme }) => theme.colors.white};

  & > ul {
    li {
      button {
        font-weight: 400 !important;
      }
    }
  }
`;
